export default __webpack_public_path__ + "static/media/tactor-grey.063ac6c7.svg";